import React, { Component } from 'react';
import cookie from 'react-cookies';
import { Route, Redirect,withRouter } from 'react-router-dom';
import { Row, Col } from 'react-flexbox-grid';
import Assumptions from 'components/assumptions/Assumptions';
import ValueJourneyWorksheet from 'components/journeys/ValueJourneyWorksheet';
import Sidebar from 'components/layouts/Sidebar';
import MainHeader from 'components/layouts/MainHeader';
import MetricForm from 'components/forecasts/MetricForm';
import ValueJourneyForm from 'components/journeys/ValueJourneyForm';
import GoalList from 'components/goals/GoalList';
import LoginForm from 'components/login/LoginForm';
import RegisterForm from 'components/login/RegisterForm';
import MonthService from 'components/commons/MonthService';
import Dashboard from 'components/dashboard/Dashboard';
import PersonaPage from 'components/assumptions/PersonaPage';
import UserList from 'components/users/UserList';
import { GoalCrudService, PersonaCrudService, MetricsCrudService, JourneyCrudService, UserCrudService } from 'utils/CrudService';
import _ from 'lodash';

import { Layout, notification, message } from 'antd';
import Goal from 'core/Goal';
import MediaQuery from 'react-responsive';
import { GoogleService } from '../../utils/GoogleService';
const { Content, Footer } = Layout;

class MainPage extends Component {
	constructor(props) {
		super(props);
		this.userCrudService = new UserCrudService();
		this.goalCrudService = new GoalCrudService();
		this.personaCrudService = new PersonaCrudService();
		this.metricsCrudService = new MetricsCrudService();
		this.journeyCrudService = new JourneyCrudService();
		this.state = { goalRedirected: false, user: props.user, collapsed: true, currentGoalId: _.get(props.user, 'goal.id', null) };
		this.basename = props.basename;
		this.googleService = new GoogleService();
		this.readCookie = this.readCookie.bind(this);

	}

	componentDidMount() {
		if (!_.get(this.state, 'user.goal')) {
			this.setState({ collapsed: false, goalRedirected: true });
		}
		this.readCookie(); 
	}

	componentWillMount() {
		if (!_.get(this.state, 'user.goal')) {
			this.setState({ collapsed: false, goalRedirected: true });
		}
	}

	readCookie(djutyid,djutyname) {
		   var djutyuser = cookie.load('djutyuser')
  
	 	   if(djutyuser != undefined &&  djutyuser != null && djutyuser !='' ){
               this.setState({ user: djutyuser });
               this.setState({ isLogged: true });
            }
            else{
            	 this.setState({ isLogged: false });
            }
 	}

	render() {
		return (
			<Layout>
				<Sidebar
					basename={this.basename}
					goalId={this.state.currentGoalId}
					collapsed={this.state.collapsed}
					user={this.state.user}
					t={this.props.t}
					i18n={this.props.i18n}
					onMenuClick={this.onMenuClick.bind(this)}
				/>
				<Layout>
					<MainHeader onLogouts={this.onLogouts.bind(this)} ref="mainHeader" googleService={this.googleService} menuClicked={this.state.collapsed} user={this.state.user} onLogout={this.onLogout.bind(this)} onMenuClick={this.onMenuClick.bind(this)} />
					<Content className="content">
						<Route
							exact={true}
							path="/"
							render={props =>
								this.state.goalRedirected ? <Redirect to="/goals" /> : <Dashboard goal={this.state.user.goal} goalCrudService={this.goalCrudService} metricsCrudService={this.metricsCrudService} />
							}
						/>
						<Route
							exact={true}
							path="/goals"
							render={props => <GoalList {...props} user={this.state.user} googleService={this.googleService} crudService={this.goalCrudService} goalId={this.state.currentGoalId} onUpdate={goal => this.setDefaultGoal(goal)} />}
						/>
						<Route exact={true} path="/assumptions/:goalId" render={props => <Assumptions {...props} goal={this.state.user.goals} crudService={this.personaCrudService} />} />
						<Route
							exact={true}
							path="/journeys/:goalId"
							onEnter={this.changeClassName.bind(this)}
							render={props => <ValueJourneyWorksheet {...props} goal={this.state.user.goals} crudService={this.journeyCrudService} />}
						/>
						<Route exact={true} path="/forecast/:type/:goalId" render={() => <MetricForm isEditable={true} />} />
						<Route exact={true} path="/revenue/:goalId" render={props => <MetricForm {...props} metricTitle="Total Revenues" type="revenues" />} />
						<Route exact={true} path="/persona/:personaId" render={props => <PersonaPage {...props} />} />
						<Route exact={true} path="/users/" render={props => this.renderWithRole('admin', <UserList {...props} currentUser={_.get(this.state, 'user')} userCrudService={this.userCrudService} />)} />
					</Content>
				</Layout>
			</Layout>
		);
	}

	renderWithRole(role, reactComponent) {
		if (_.get(this.state, 'user.role') === role) {
			return reactComponent;
		} else {
			return <Redirect to="/" />;
		}
	}

	onMenuClick(collapsed) {
		this.setState({ collapsed });
	}

	changeClassName(e) {
		console.log(e);
	}

	async onLogout(user) {
		if (this.props.onUpdate) {
			this.props.onUpdate(null);
			this.setState({ user: null });
		}
	}

	onLogouts(){
  		this.props.onUpdate(null);
 		this.props.history.push('/');
 	}

	checkDefaultGoal() {
		return _.get(this.state, 'currentGoalId') ? <Redirect to="/goals" /> : '';
	}

	async setDefaultGoal(goal) {
		const currentGoalId = goal.id;
		const isSuccess = await this.userCrudService.changeDefaultGoal(this.state.user.id, currentGoalId);
		if (isSuccess) {
			const user = this.state.user.withGoal(goal);
			this.setState({ currentGoalId, user }, () => {
				if (this.props.onUpdate) {
					this.props.onUpdate(user);
				}
				message.success('Default goal successfully changed');
			});
		} else {
			notification.error({ message: 'Changes were not successfull' });
		}

		return isSuccess;
	}

	populateMonthlyMetrics(goals, metrics, metricName) {
		const metricValue = goals[metricName];
		const { goal, stretch } = metricValue;
		if (_.isEmpty(metrics[metricName])) {
			metrics[metricName] = MonthService.createMetricValues(goals.startDate, goals.endDate, goal, stretch);
		} else {
			metrics[metricName] = MonthService.updateMetricValues(goals.startDate, goals.endDate, goal, stretch, metrics[metricName]);
		}
	}
}

export default withRouter(MainPage);



// WEBPACK FOOTER //
// ./src/components/pages/MainPage.js